import { render, staticRenderFns } from "./paymentmethod.vue?vue&type=template&id=3115f89e&"
import script from "./paymentmethod.vue?vue&type=script&lang=ts&"
export * from "./paymentmethod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports